/** @jsx jsx */
import React from "react";
import { css, jsx } from "@emotion/core";
import FormSubmitArea from "components/atoms/Form/FormSubmitArea";
import PrimaryButton from "components/atoms/Button";
import FormField from "components/atoms/Form/FormField";
import FileSelectButton from "components/molecules/FileSelectButton";
import { utilityColor } from "components/styles";
import BodyText from "components/atoms/BodyText";
import useExecutiveCsvForm from "./hooks";
import FlexBox from "components/atoms/FlexBox";
import { useHistory } from "react-router-dom";
import Modal from "components/molecules/Modal";

const style = {
  uploadFileCSV: css({
    marginTop: '30px',
    height: '105px',
    width: '400px',
    border: '1px solid #dcdcdc',
    borderRadius: '2px',
    backgroundColor: '#f8f8f8',
    justifyContent: 'center',
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
  }, css`
  span {
    position: absolute;
    left: 95px;
  }
  button {
    margin-left: 35px;
  }
`),
};

const ExecutiveImportCSV: React.FC = () => {
  const history = useHistory();
  const {
    setUploadFile,
    uploadFile,
    onSubmit,
    errors,
    confirmModalOpen,
    closeConfirmModal,
    handleSubmit,
    inputValue,
  } = useExecutiveCsvForm();
  return (
    <div style={{ textAlign: "center" }}>
      <FlexBox
        customStyle={css({
          justifyContent: "center",
          width: "400px",
          margin: "auto",
          flexWrap: "wrap",
        })}
      >
        <div css={style.uploadFileCSV}>
          <FileSelectButton
            text="CSVファイルをアップロード"
            ghost={true}
            setFile={setUploadFile}
            value={inputValue}
            accept="text/csv,.csv,application/vnd.ms-excel"
          />
        </div>
        <div style={{ width: "100%", textAlign: "left" }}>
          <BodyText color={utilityColor.error} size="sm">
            CSVファイルの1行目（ヘッダー行）はインポートされません。
          </BodyText>
        </div>
      </FlexBox>

      {uploadFile || errors ? (
        <FormField displayBlock={true}>
          <div>{uploadFile?.name}</div>
          {errors &&
            errors.map((error) => (
              <div key={error}>
                <BodyText color={utilityColor.error}>{error}</BodyText>
              </div>
            ))}
        </FormField>
      ) : null}
      <FormSubmitArea
        customStyle={css({ width: "160px", margin: "30px auto" })}
      >
        <PrimaryButton
          text="インポート"
          onClick={handleSubmit}
          disabled={!uploadFile}
          fullwidth={true}
        />
        <PrimaryButton
          text="戻る"
          ghost={true}
          fullwidth={true}
          // eslint-disable-next-line no-restricted-globals
          onClick={() => history.push("/executive")}
        />
      </FormSubmitArea>
      <Modal
        open={confirmModalOpen}
        closeHandler={closeConfirmModal}
        title="ファイルをアップロード"
        submitText="アップロードする"
        note="ファイルをアップロードします。よろしいですか？"
        onSubmit={onSubmit}
      >
        <div style={{ height: "40px" }}></div>
      </Modal>
    </div>
  );
};

export default ExecutiveImportCSV;
